import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import Home from './pages/Home';
import Produtos from './pages/Produtos';
import ProdutoDetalhe from './pages/ProdutoDetalhe';
import CadastroCliente from './pages/CadastroCliente';
import Login from './pages/Login';
import LoginAdmin from './pages/LoginAdmin';
import DashboardAdmin from './pages/DashboardAdmin';
import Lancamentos from './pages/Lancamentos';
import Carrinho from './pages/Carrinho';
import Checkout from './pages/Checkout';
import MinhaConta from './pages/MinhaConta';
import ListaDesejos from './pages/ListaDesejos';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <WishlistProvider>
          <Router>
            <div className="App">
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/produtos" element={<Produtos />} />
                  <Route path="/lancamentos" element={<Lancamentos />} />
                  <Route path="/produto/:id" element={<ProdutoDetalhe />} />
                  <Route path="/cadastro-cliente" element={<CadastroCliente />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/carrinho" element={<Carrinho />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/minha-conta" element={<MinhaConta />} />
                  <Route path="/lista-desejos" element={<ListaDesejos />} />
                  <Route path="/admin/login" element={<LoginAdmin />} />
                  <Route 
                    path="/admin/dashboard" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <DashboardAdmin />
                      </ProtectedRoute>
                    } 
                  />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <ToastContainer position="top-right" autoClose={3000} closeOnClick theme="light" />
            </div>
          </Router>
        </WishlistProvider>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;

